exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-Regions-___Regions__thead___3TmWc th{font-size:12px!important;font-weight:400;color:#757575;vertical-align:top;text-align:left}.src-components-Regions-___Regions__thead___3TmWc tr:last-child th{padding-top:3px;padding-bottom:6px}.src-components-Regions-___Regions__tbody___W1KDo td{font-size:13px!important;color:rgba(0,0,0,.87);padding:5px 0}.src-components-Regions-___Regions__regionNameText___ndQdy{font-size:13px!important;font-weight:500;cursor:pointer;transition:color .2s linear;line-height:20px;vertical-align:top}.src-components-Regions-___Regions__summary___3zrGr{margin-left:28px}.src-components-Regions-___Regions__regionNameText___ndQdy:hover{color:#0097a7}.src-components-Regions-___Regions__icon___3PLlC{height:20px!important;margin-right:8px;margin-top:-2px;width:20px!important;vertical-align:top!important}@media only screen and (max-width:500px){.src-components-Regions-___Regions__heading___Swmme{margin-top:1em!important}}", ""]);

// exports
exports.locals = {
	"thead": "src-components-Regions-___Regions__thead___3TmWc",
	"tbody": "src-components-Regions-___Regions__tbody___W1KDo",
	"regionNameText": "src-components-Regions-___Regions__regionNameText___ndQdy",
	"summary": "src-components-Regions-___Regions__summary___3zrGr src-components-Regions-___Regions__regionNameText___ndQdy",
	"icon": "src-components-Regions-___Regions__icon___3PLlC",
	"heading": "src-components-Regions-___Regions__heading___Swmme"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./src/components/Regions/Regions.css
// module id = 477
// module chunks = 0